import moment from 'moment';
import { BikeStation, Place } from '../models';
import { HttpService } from './http';
export class BikeStationService {
  static async getBikeStations({
    ids,
    bounds
  } = {}) {
    try {
      const queryParams = [];
      if (ids) queryParams.push(...ids.map(id => ({
        key: 'ids[]',
        value: id
      })));else if (bounds) {
        const {
          north,
          east,
          south,
          west
        } = bounds;
        queryParams.push({
          key: 'north',
          value: north
        }, {
          key: 'east',
          value: east
        }, {
          key: 'south',
          value: south
        }, {
          key: 'west',
          value: west
        });
      } else throw new Error('missing query params');
      const data = await HttpService.get('v2', `/bikestations`, queryParams);
      const bikeStations = data.map(parseBikeStation);
      return bikeStations;
    } catch (err) {
      console.error('[BikeStationService][getBikeStations]', err);
      throw err;
    }
  }
  static async getBikeStation(id, {
    history
  } = {}) {
    try {
      const queryParams = [];
      if (history) queryParams.push({
        key: 'history',
        value: true
      });
      const data = await HttpService.get('v2', `/bikestations/${id}`, queryParams);
      const bikeStation = parseBikeStation(data);
      return bikeStation;
    } catch (err) {
      console.error('[BikeStationService][getBikeStation]', err);
      throw err;
    }
  }
}
export function parseBikeStation({
  id,
  number,
  label,
  location,
  address,
  capacity,
  availableClassicBikes,
  availableEBikes,
  availablePlaces,
  vlsProvider,
  updated,
  status,
  history
}) {
  let days = 0;
  return new BikeStation(id, number, label, new Place(undefined, location, {
    primaryText: address
  }), capacity, availableClassicBikes, availableEBikes, availablePlaces, vlsProvider, moment(updated), status === 'OPEN' ? 'open' : 'closed', history ? history.map(({
    availableClassicBikes,
    availableEBikes,
    availablePlaces: availableLots,
    hour
  }) => {
    if (hour === 23) --days;
    return {
      availableClassicBikes,
      availableEBikes,
      availableLots,
      date: moment().add(days, 'days').set('hours', hour).startOf('hour')
    };
  }) : undefined);
}